// extracted by mini-css-extract-plugin
module.exports = {"footer":"EditableLayout_footer__35Hlf"};